import React from "react";
import "./ModalFinishedPlays.scss";
import SimpleContent from "../SimpleContent/SimpleContent";
import locale from "../../assets/locale.json";
import finished_plays_image from "../../assets/images/finished_plays.webp";
import Modal from "../Modal/Modal";
import { ModalActionProps } from "../../models/modalAction";

const ModalFinishedPlays: React.FC<ModalActionProps> = ({ isOpen, onClose }) => {
    const { finished_plays: { altImg, title, description, buttonLabel } } = locale;

    return (
        <div className="pw-finished-plays-modal">
            <Modal isOpen={isOpen} onClose={onClose}>
                <div className="pw-finished-plays-container">
                    <SimpleContent
                        image={{ alt: altImg, src: finished_plays_image }}
                        title={title}
                        description={() =>
                            <p className="pw-simple-content-description paragraph-semi-bold-small">
                                {description}
                            </p>
                        }
                        confirmationButton={{
                            theme: "blue",
                            label: buttonLabel,
                            onClick: onClose,
                            className: "pw-button-finished-plays"
                        }}
                    />
                </div>
            </Modal>
        </div>
    )
}

export default ModalFinishedPlays